import CartObject from "../helpers/cartUtil";
import Util from "../helpers/util";
import GoogleMapsApi from "../helpers/GoogleMapsApi";
import { getImageUrl, getVendorBusinessImageUrl } from "../helpers/mediaUrl";

// Using shared singleton instance
var UtilObject = new Util();
var GoogleMapsApiObject = new GoogleMapsApi();

var addressCode;
var couponsForVendor;
var vendor;
var quantityDebounceTimer = null;
const QUANTITY_DEBOUNCE_MS = 300;
const pendingQuantityUpdates = {};

export default class customerCartPage {
  constructor() {
    // Check if user is logged in
    var allCookies = UtilObject.getAllCookies() || {};
    var customerId = allCookies.CUSTOMER_ID;

    // We no longer redirect guests immediately. 
    // They can view the cart, but will be prompted to login on checkout.
    if (!customerId) {
      console.log("Viewing cart as guest");
    }

    //Initially Hide the EmptyCart Page
    //$(".emptyCartPage").hide();

    this.placeCartOrder = $("#placeCartOrder");
    this.cartPageSkeleton = $(".cart-page-skeleton");
    this.messageAdError = $("#deliveryAdreessMesaggeError");
    this.messageDeliveryAdError = $("#deliveryAdressSelectMesaggeError");
    // this.messageCouponError = $(".messageCouponError");

    this.deliveryOption = $(".cartdeliveryOption");

    //coupons validation
    this.messageCouponError = $("#messageCouponError");
    this.couponEntered = $(".couponEntered");
    this.applyCouponOption = $("#applycouponbtn");
    this.removeCouponOption = $("#removecouponbtn");
    // this.couponMessage = $("#couponMessage");
    this.applyCouponBox = $(".applyCouponBox");
    this.removeCouponBox = $(".removeCouponBox");
    this.removeCouponBtn = $(".CouponRemoveBtn ");

    //adress validation
    this.inputAddressName = $(".inputAddressNameChange");
    this.inputAddress = $(".inputAddressChange");
    this.inputAddressshort = $(".inputAddressshortChange");
    this.inputCity = $(".inputCityChange");
    this.inputState = $(".inputStateChange");
    this.inputPincode = $(".inputPincodeChange");

    this.inputAddressNameError = $(".inputAddressNameError");
    this.inputAddressError = $(".inputAddressError");
    this.inputAddressshortError = $(".inputAddressshortError");
    this.inputCityError = $(".inputCityError");
    this.inputStateError = $(".inputStateError");
    this.inputpincodeError = $(".inputpincodeError");

    // Register events once products are loaded
    this.boundEventsStatus = false;
    $("a.continueShoppingBtn").on("click", this.maintainFlow);

    // Run display logic when ready
    if (document.readyState === "complete") {
      this.cartCheckAndDisplayOnPage();
    } else {
      $(window).on("load", () => {
        this.cartCheckAndDisplayOnPage();
      });
    }

    document.addEventListener("cart-updated", this.refreshCartCount);
  }

  hideCartPageSkeleton = () => {
    this.cartPageSkeleton.addClass("d-none");
  };

  bindEvents = () => {
    this.placeCartOrder = $("#placeCartOrder");
    console.log("Locaso: Binding Place Enquiry event to:", this.placeCartOrder.length ? "FOUND" : "NOT FOUND");
    this.placeCartOrder.on("click", this.placeOrderCheck);

    // Use event delegation for dynamic elements
    $(document).off("click", ".cartdeliveryOption").on("click", ".cartdeliveryOption", this.deliveryOpt);
    this.getAddressDetailsOnload();

    $(document).off("click", ".cartAddressItem").on("click", ".cartAddressItem", this.getAllVendorDeliveryoptions);

    $(".cartAdressSubmitButton").on("click", this.addAdressValidationCheck);

    //$(window).on("load", () => { this.getAllVendorDeliveryoptions(); });

    //hide delivery message error
    this.messageAdError.hide();
    this.messageDeliveryAdError.hide();

    $(".deliveryoptions").hide();

    //testing

    //coupons part

    //$(".couponBarBtn").on("click", this.getAllCoupons);
    this.applyCouponOption.on("click", this.applyCouponOpt);
    this.removeCouponOption.on("click", this.removeCoupon);
    this.removeCouponBox.hide();
    // // $(".couponBarApplyBtn").on("click", this.applyCoupon);
    // $(".CouponRemoveBtn ").on("click", () => {
    //   $(".applyCouponBox").show();
    // });
    //button for login
    $(".customerNotLoggedInCartBtn").on("click", () => {
      UtilObject.setRedirectAfterLogin(window.location.href);
      $("#customerNotLoggedInCart").show();
    });
    $("#customerNotLoggedInCartClose").on("click", () => {
      $("#customerNotLoggedInCart").hide();
    });

    // button for location modal
    $(document).on("click", ".mapAddressForCart", () => {
      $("#locationCallCart").show();
    });
    $(".locationCallCartClose").on("click", () => {
      $("#locationCallCart").hide();
    });
    // $(".textareaCouponDesktop").on("click", () => {
    //   // if ($(".textareaCouponDesktop").val()) {
    //   $(".recentCouponsDesktop").show();
    //   // } else {
    //   //   $(".recentCouponsDesktop").hide();
    //   // }
    // });
    //on click on cancel coupon button show all coupons
    $("#removecouponbtn").on("click", () => {
      // if ($(".textareaCouponDesktop").val()) {
      $(".recentCouponsDesktop").show();
      // } else {
      //   $(".recentCouponsDesktop").hide();
      // }
    });

    $("#customerCartPageFinalModalClose").on("click", () => {
      $("#customerCartPageFinalModal").hide();
    });

    $("#customerCartPageFinalModalAcceptButton").on("click", (e) => {
      const btn = $(e.currentTarget);
      btn.prop("disabled", true).html('<i class="fa fa-spinner fa-spin me-2"></i>Processing...');
      this.Submit_Cart();
    });

    //$(window).on("load", () => { this.cartCheckAndDisplayOnPage(); });
    $(".backToShoppingBtn").on("click", this.maintainFlow);
    //coupons part
    this.getAllCoupons();
  };

  // placeOrderCheck = () => {
  //   //hide error message
  //   this.messageAdError.hide();
  //   this.messageDeliveryAdError.hide();

  //
  //   let isAddressValidated = this.address_validate();
  //   let isDeliveryAdressValidated = this.deliveryAddress_validate();

  //   if (isAddressValidated) {
  //     this.messageAdError.hide();
  //     //check delivery type
  //     var addressCheck = document.querySelector(
  //       'input[name="optDeliveryradio"]:checked'
  //     );
  //     //check if user selects other than pickup
  //
  //     if (addressCheck.value != "Self Pickup") {
  //       if (isDeliveryAdressValidated) {
  //         this.messageDeliveryAdError.hide();
  //         this.Submit_Cart();
  //       }
  //     } else {
  //       this.messageDeliveryAdError.hide();
  //       var customer = UtilObject.getAllCookies();
  //       //user check
  //       $.ajax({
  //         url: baseURL + "api/customer/Account/GetUserDetails",
  //         type: "POST",
  //         data: {
  //           Customer_ID: customer.CUSTOMER_ID,
  //         },
  //         success: function (result) {
  //
  //           //dubmit cart if sucess
  //           this.Submit_Cart();
  //         },
  //         error: function (err) {
  //
  //           $("#customerNotLoggedInCart").show();
  //         },
  //       });
  //     }
  //   }
  // };

  maintainFlow = () => {
    var allCookies = UtilObject.getAllCookies();

    //window.location = allCookies.PREVIOUS_PAGE;
    history.go(-1);
  };

  placeOrderCheck = () => {
    // //Check for Vendor Availability
    // var cart = CartObject.cartCheck();
    // var dt = new Date();
    // var day = dt.toLocaleDateString("en", { weekday: "long" });
    // var time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    // var checkIfVendorAvailable = true;

    //
    //

    // var vendorAvailability = cart.vendor.Availability;
    //

    // vendorAvailability.forEach((avail) => {
    //   if (avail.Day == day) {
    //
    //     if (avail.Available == 1) {
    //
    //       if (time >= avail.Start_time && time <= avail.End_time) {
    //
    //
    //
    //
    //
    //
    //         $(".vendorAvailabilityMessage").hide();
    //       } else {
    //
    //
    //
    //
    //
    //
    //         $(".vendorAvailabilityMessage").show();
    //       }
    //     }
    //   }
    // });
    // //Check for Vendor Availability Ends

    //hide error message
    this.messageAdError.hide();
    this.messageDeliveryAdError.hide();

    // If guest, show login modal before validating address
    var allCookies = UtilObject.getAllCookies();
    if (!allCookies.CUSTOMER_ID) {
      UtilObject.setRedirectAfterLogin(window.location.href);
      $("#customerNotLoggedInCart").show();
      return;
    }

    let isAddressValidated = this.address_validate();
    let isDeliveryAdressValidated = this.deliveryAddress_validate();

    if (isAddressValidated) {
      this.messageAdError.hide();
      //check delivery type
      var addressCheck = document.querySelector(
        'input[name="optDeliveryradio"]:checked',
      );
      //check if user selects other than pickup
      if (addressCheck.value != "Self Pickup") {
        if (isDeliveryAdressValidated) {
          this.messageDeliveryAdError.hide();
          $("#customerCartPageFinalModal").show();
        }
      } else {
        //cart order with delivery
        this.messageDeliveryAdError.hide();
        $("#customerCartPageFinalModal").show();
      }
    }
  };

  Submit_Cart = async () => {
    // Delivery Option
    var addressDeliveryCheck = $(
      `input[name="optDeliveryradio"]:checked`,
    ).val();

    // Customer Address
    var addressCheck = $(`input[name="optDeliveryAdressradio"]:checked`).val();

    // Updating Details in the DB for Order
    $.ajax({
      url: baseURL + "api/customer/Cart/finalPlaceOrder",
      type: "POST",
      data: {
        Customer_Address_ID: addressCheck,
        Delivery_ID: addressDeliveryCheck,
      },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        if (result == true || result.status == true) {
          CartObject.notifyCartUpdate();
          window.location.href = baseURL + "customer/confirmationPage/" + result.Order_ID;
        } else {
          $("#customerCartPageFinalModalAcceptButton").prop("disabled", false).text("Accept");
          let msg = result.Msg || "Something went wrong.";
          $(".finalPlaceOrderErrorMessage").html(msg);
          if (typeof window.$ !== "undefined" && typeof window.$.fn.modal !== "undefined") {
            window.$("#finalPlaceOrderError").modal("show");
          } else {
            alert(msg);
          }
        }
      },
      error: (error) => {
        $("#customerCartPageFinalModalAcceptButton").prop("disabled", false).text("Accept");
        let msg = "Some of the products in your cart has gone out of stock, Kindly refresh the cart";
        if (error.responseJSON && error.responseJSON.Msg) {
          msg = error.responseJSON.Msg;
        }
        $(".finalPlaceOrderErrorMessage").html(msg);
        if (typeof window.$ !== "undefined" && typeof window.$.fn.modal !== "undefined") {
          window.$("#finalPlaceOrderError").modal("show");
        } else {
          alert(msg);
        }
      },
    });
  };

  //delivery option
  deliveryOpt = () => {
    //hide error message
    this.messageAdError.hide();
    this.messageDeliveryAdError.hide();

    var addressCheck = document.querySelector(
      'input[name="optDeliveryradio"]:checked',
    );

    //check if user selects other than pickup
    if (addressCheck.value == "Self Pickup") {
      $('input[name="optDeliveryAdressradio"]:checked').prop("checked", false);
      this.messageDeliveryAdError.hide();
    }
  };

  //call to check for adresss
  getAddressDetailsOnload = () => {
    var customer = UtilObject.getAllCookies();
    $(".cartUserSavedAdress").empty();

    //user check
    if (!customer.CUSTOMER_ID) {
      $(".signInCartBtn").removeClass("d-none");
      $(".addressCartBtn").addClass("d-none");
      return;
    }
    // If logged in, ensure we show the address-related buttons immediately
    $(".signInCartBtn").addClass("d-none");
    $(".addressCartBtn").removeClass("d-none");

    UtilObject.getAddresses(customer.CUSTOMER_ID).then((result) => {
      // Ensure the button is visible and use it as a prompt if no addresses exist
      if (!result || result.length === 0) {
        $(".cartUserSavedAdress").html(
          `<div class="col-12 p-3 text-center">
            <p class="text-muted">No addresses found.</p>
            <button class="btn text-white toggleMap mapAddressForCart" data-bs-toggle="modal" data-bs-target="#locationCallCart" style="background: #ff385c;">
              <i class="fa fa-plus me-2"></i> Add New Address
            </button>
          </div>`,
        );
      } else {
        result.forEach((element) => {
          var item = `
            <label class="address-card-label cartAddressItem">
                <input id="${element.Customer_Address_ID}" type="radio" name="optDeliveryAdressradio" class="card-input-elementCart" value="${element.Customer_Address_ID}" />
                <div class="address-card">
                    <div class="address-card-name">${element.Address_Name}</div>
                    <div class="address-card-text">${element.Address_Line_1}</div>
                    <input type="hidden" name="lat" value="${element.lat}" />
                    <input type="hidden" name="lon" value="${element.lon}" />
                </div>
            </label>`;

          $(".cartUserSavedAdress").append(item);
        });

        // Events are now handled via delegation in bindEvents()

        if (result.length == 1) {
          $(`#${result[0].Customer_Address_ID}`).attr("checked", "checked");
          $(".cartAddressItem").trigger("click");
        }
      }
    });
  };

  ///address check
  address_validate = () => {
    let flag = true;
    var addressCheck = document.querySelector(
      'input[name="optDeliveryradio"]:checked',
    );
    if (addressCheck == null) {
      this.messageAdError.show();
      flag = false;
    }

    return flag;
  };

  //getting all categories by clicking on hamburger menu
  getAllVendorDeliveryoptions = async (event) => {
    //Error messages
    //this.messageAdError.hide();
    this.messageDeliveryAdError.hide();

    var lat = parseFloat(
      $(event.currentTarget).find("input[name='lat']").val(),
    );
    var lng = parseFloat(
      $(event.currentTarget).find("input[name='lon']").val(),
    );

    // 2. Fetch current cart to get vendor ID and location
    const currentCart = await CartObject.cartCheck();
    if (!currentCart || !currentCart.vendor) {
      console.warn("No vendor information available to fetch delivery options.");
      return;
    }

    // 3. Calculate distance to vendor
    const vendorAddr = currentCart.vendor.Address || {};
    const vLat = parseFloat(vendorAddr.lat);
    const vLng = parseFloat(vendorAddr.lon);

    let distanceToVendor = 0;
    if (!isNaN(lat) && !isNaN(lng) && !isNaN(vLat) && !isNaN(vLng)) {
      distanceToVendor = UtilObject.distance(lat, lng, vLat, vLng);
    }

    // var currentLocation =
    //   await GoogleMapsApiObject.navigatorGeolocationForCurrentLocation();
    //

    await new Promise((resolve) => {
      $.ajax({
        url: baseURL + "api/customer/Homepage/getDeliveryOptions",
        type: "POST",
        data: {
          Vendor_ID: currentCart.vendor.Vendor_ID,
          Distance: distanceToVendor,
        },
        headers: { Authorization: X_API_KEY },
        success: (result) => {
          resolve(result);
        },
        error: (result) => {
          resolve(null);
        },
      });
    }).then((result) => {
      if (!result) return;
      $(".deliveryoptions").show();
      $(".deliveryOptionsItems").empty();
      var sp = true,
        fd = true,
        pd = true;
      result.forEach((deliveryoption) => {
        let icon = "fa-person-walking";
        if (deliveryoption.Delivery_Type == "RSKM") icon = "fa-truck";
        if (deliveryoption.Delivery_Type == "KM") icon = "fa-bicycle";

        var deliveryOptionItem = `
          <label class="w-100 mb-2 cursor-pointer">
              <input type="radio" class="card-input-elementCart cartdeliveryOption" id="${deliveryoption.Delivery_ID}" name="optDeliveryradio" value="${deliveryoption.Delivery_ID}">
              <div class="address-card address-card-horizontal d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center gap-3">
                      <div class="bg-light p-2 rounded-circle">
                          <i class="fa-solid ${icon} text-brand"></i>
                      </div>
                      <div>
                          <div class="fw-bold small">${deliveryoption.Delivery_Name || (deliveryoption.Delivery_Type == 'None' ? 'Self Pickup' : 'Home Delivery')}</div>
                          <div class="text-muted extra-small">${deliveryoption.Distance_kms} KMS</div>
                      </div>
                  </div>
                  <div class="fw-bold text-brand">₹ ${deliveryoption.Price}/-</div>
              </div>
              <input type="hidden" name="${deliveryoption.Delivery_ID}" value="${deliveryoption.Price}">
          </label>`;

        $(".deliveryOptionsItems").append(deliveryOptionItem);
      });
      //Hides Delivery options error message
      $(".cartdeliveryOption").on("click", this.showInDetailedBill);
    });
  };

  showInDetailedBill = (event) => {
    this.messageAdError.hide();

    var deliveryId = event.currentTarget.value;
    var price = $(`input[name="${deliveryId}"]`);
    price = price[0];
    price = price.value;
    $(".deliveryCharges").html(price);
    this.detailedBill();
  };

  ///delivery adress validate check
  deliveryAddress_validate = () => {
    let flag = true;
    var addressDeliveryCheck = document.querySelector(
      'input[name="optDeliveryAdressradio"]:checked',
    );
    if (addressDeliveryCheck == null) {
      this.messageDeliveryAdError.show();
      flag = false;
    }

    return flag;
  };
  //For Coupons <start>

  //GET all the coupons
  getAllCoupons = async (cart) => {
    if (!cart) {
        cart = await CartObject.cartCheck();
    }

    var inputDesktop = $(".CouponBar").val();
    if (inputDesktop == "") {
      var input = inputDesktop;
    }

    $.ajax({
      url: globalThis.baseURL + "api/customer/Cart/GetCoupons",
      type: "POST",
      data: {
        Vendor_ID: cart.vendor.Vendor_ID,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        couponsForVendor = result;
        $(".couponBarRemoveBtn").hide();
        $(".recentCouponsDesktop").empty();
        if (!result.hasOwnProperty("code")) {
          $(".recentCouponsDesktop").append(
            `<p class="card-header "><strong>Coupons that can be applied</strong></p>`,
          );
          result.forEach((element) => {
            var item = `   <div class="  card shadow  recentCouponsDesktopItems">
  
            
            <div class="card-body d-inline-block text-truncate text-break">
         
            <a class=" dropdown-item recentCouponItems stretched-link text-success"><strong>${element.Coupon_Code}</a>
        <p class="dropdown-header text-wrap">Coupon Description : ${element.Coupon_Description}
          </p>
        
          </div>
       
          
        </div>
        
        `;
            $(".recentCouponsDesktop").append(item);
          });

          $(".recentCouponItems").on(
            "click",
            this.enterCouponValueInsideCouponBox,
          );
        }
      },
      error: (result) => {},
    });
  };

  enterCouponValueInsideCouponBox = (recentCouponItem) => {
    var recentCouponItem = recentCouponItem.target.text;
    $(".CouponBar").val(recentCouponItem);
    this.messageCouponError.html("");
  };
  //validation for coupon submit
  applyCouponOpt = (e) => {
    e.preventDefault();

    if (this.couponEntered.val() != "") {
      var enteredCoupon = this.couponEntered.val();

      this.checkCoupon(enteredCoupon);
    } else {
      this.messageCouponError.html("Please Enter Coupon Code!");
    }
  };

  checkCoupon = (enteredCoupon) => {
    $("#messageCouponError").removeClass("text-success");
    $("#messageCouponError").addClass("text-danger");

    if (couponsForVendor.length > 0) {
      couponsForVendor.forEach((coupon) => {
        if (coupon.Coupon_Code == enteredCoupon) {
          this.applyCoupon(coupon);
        }
      });
    } else {
      this.messageCouponError.html("No Coupons Exists for this Vendor !");
    }
  };

  applyCoupon = async (coupon) => {
    var cart = await CartObject.cartCheck();

    var orderId = cart.Order.Order_ID;

    $.ajax({
      url: globalThis.baseURL + "api/customer/Cart/ApplyCoupon",
      type: "POST",
      data: {
        Order_ID: orderId,
        Coupon_ID: coupon.Coupon_ID,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        $("#messageCouponError").removeClass("text-danger");
        $("#messageCouponError").addClass("text-success");
        this.messageCouponError.html("Coupon Code Applied!");
        $("#messageCouponError").show();
        $(".recentCouponsDesktop").hide();
        this.applyCouponBox.hide();
        this.removeCouponBox.show();

        this.detailedBill(cart);
      },
      error: (result) => {
        $("#messageCouponError").removeClass("text-success");
        $("#messageCouponError").addClass("text-danger");
        $("#messageCouponError").html(result.responseJSON.Msg);
        $("#messageCouponError").show();
      },
    });
  };

  removeCoupon = async (coupon) => {
    var cart = await CartObject.cartCheck();

    var orderId = cart.Order.Order_ID;

    $.ajax({
      url: globalThis.baseURL + "api/customer/Cart/RemoveCoupon",
      type: "POST",
      data: {
        Order_ID: orderId,
        Coupon_ID: coupon.Coupon_ID,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        this.couponEntered.val(null);
        $(".applyCouponBox").show();
        this.removeCouponBox.hide();
        this.messageCouponError.html("");

        this.detailedBill(cart);
      },
      error: (result) => {},
    });
  };
  //coupon <end>

  cartCheckAndDisplayOnPage = async (forceRefresh = false) => {
    try {
      this.hideCartPageSkeleton();
      var currentCart = await CartObject.cartCheck(forceRefresh);
      var phpCookies = UtilObject.getPhpCookies();

      if (
        !currentCart ||
        !currentCart.Products ||
        (currentCart.Products.length == 0 &&
          (!currentCart.Products_Not_Available || currentCart.Products_Not_Available.length == 0))
      ) {
        $(".emptyCartPage").removeClass("d-none");
      } else {
        if (!this.boundEventsStatus) {
          this.bindEvents();
          this.boundEventsStatus = true;
        }
        $(".mainCartPageContent").removeClass("d-none");
        this.showVendorOnCartPage(currentCart);
        await this.showProductsOnCartPage(currentCart);
        this.detailedBill(currentCart);
        this.getAllCoupons(currentCart);
      }
      CartObject.notifyCartUpdate();
    } catch (error) {
      console.error("Error in cart display logic:", error);
      // Fallback: hide skeleton to prevent infinite loading state
      this.hideCartPageSkeleton();
    }
  };

  showVendorOnCartPage = async (cart) => {
    if (!cart || !cart.vendor) return;
    vendor = cart.vendor;
    var vendorDeliveryOptions = cart.Delivery_options || [];

    var vendorName = vendor.Business_Name || "Vendor";
    if (vendorName.length > 32) {
      vendorName = vendorName.slice(0, 32) + "...";
    }

    var canCheck = true;
    var showDelivery = "";
    vendorDeliveryOptions.forEach((DO) => {
      if (
        DO.Delivery_Name == "Free Delivery" &&
        DO.IsAvailable == "1" &&
        canCheck == true
      ) {
        showDelivery = `Free ${DO.Distance_kms} KMS`;
        canCheck = false;
      } else if (
        DO.Delivery_Name == "Self Pickup" &&
        DO.IsAvailable == "1" &&
        canCheck == true
      ) {
        showDelivery = `Self Pickup`;
      } else if (
        DO.Delivery_Type == "RSKM" &&
        DO.IsAvailable == "1" &&
        canCheck == true
      ) {
        showDelivery = `Paid-Delivery ${DO.Distance_kms} KMS - ₹${DO.Price}`;
      }
    });

    let vendorRating = "";
    if (vendor.Vendor_Rating > 0) {
      vendorRating = `<p class="card-text p-0 m-0"><small class="text-muted"> ${vendor.Vendor_Rating}<i class="fa fa-star"> </i></small></p>`;
    }
    var vendorImg = getVendorBusinessImageUrl(vendor.Image_URL, 1);
    var vendorAddress = vendor.Address || {};
    var addressStr = [vendorAddress.Address_Line_1, vendorAddress.City, vendorAddress.State].filter(Boolean).join(", ");    var vendorDetailsDisplayOnCartPage = `
        <div class="cart-vendor-header mb-0 mb-md-4">
            <img src="${vendorImg}" class="cart-vendor-img" alt="${vendorName}">
            <div class="flex-grow-1">
                <div class="cart-vendor-name">${vendorName}</div>
                <div class="cart-vendor-address">${addressStr}</div>
                <div class="vendor-meta d-flex align-items-center mt-1 small text-muted">
                    ${parseFloat(vendor.Vendor_Rating) > 0 
                        ? `<span><i class="fa fa-star text-warning me-1"></i>${vendor.Vendor_Rating}</span>` 
                        : `<span class="badge bg-success text-white px-2 py-0.5" style="font-size: 0.65rem; font-weight: 800; border-radius: 4px;">NEW</span>`}
                    <span class="opacity-50 mx-2">•</span>
                    <span>₹${vendor.Minimum_Order || 0} Min Order</span>
                    <span class="opacity-50 mx-2">•</span>
                    <span class="text-brand fw-bold">${showDelivery}</span>
                </div>
            </div>
            <div class="ms-auto d-none d-md-block">
                <a href="${baseURL}customer/productListing/${vendor.Vendor_URL}" class="btn btn-outline-brand rounded-pill px-4 btn-sm">
                    View Store
                </a>
            </div> 
        </div>
        <div class="d-block d-md-none mt-3 pt-3 border-top">
            <a href="${baseURL}customer/productListing/${vendor.Vendor_URL}" class="btn btn-outline-brand rounded-pill w-100 btn-sm py-2 fw-bold">
                View Store
            </a>
        </div>`;

    $(".vendorDetailsCartPage").html(vendorDetailsDisplayOnCartPage);
  };

  showProductsOnCartPage = async (cart) => {
    if (!cart) return;

    var cartProducts = cart.Products || [];
    var cartProductsNotAvaialable = cart.Products_Not_Available || [];

    if (cartProducts.length == 0) {
      if (cartProductsNotAvaialable.length == 0) {
        $(".mainCartPageContent").addClass("d-none");
        $(".emptyCartPage").removeClass("d-none");

        //Deleting Entire Cart

        $.ajax({
          url: globalThis.baseURL + "api/customer/Cart/DeleteCart",
          type: "POST",
          data: {
            Order_ID: cart.Order.Order_ID,
          },
          headers: { Authorization: globalThis.X_API_KEY },
          success: (result) => {},
          error: (err) => {},
        });
      } else {
        $(".productsExistInCart").addClass("d-none");
        $(".mainCartPageContent").removeClass("d-none");
        $(".emptyCartPage").addClass("d-none");

        $(".productsOutOfStock").empty();

        $(".itemsOutOfStockCount").html(cartProductsNotAvaialable.length);

        cartProductsNotAvaialable.forEach((product) => {
          var productGST = product.Price * (product.GST / 100);
          productGST = Math.round(productGST);
          var IsVegOrNonVeg = "";

          if (product.Veg_NonVeg_flag != false) {
            if (product.Veg_NonVeg_flag == "Non-Veg") {
              IsVegOrNonVeg = `<div class="col-5 d-flex justify-content-end pl-0">
              <h5 class="card-title text-danger">Non-Veg</h5>
          </div>`;
            } else {
              IsVegOrNonVeg = `<div class="col-5 d-flex justify-content-end pl-0">
              <h5 class="card-title text-success">Veg</h5>
          </div>`;
            }
          }

          const productDetails = product.Product_Details || {};
          const productURL = productDetails.product_URL || "#";
          const productID = productDetails.Product_ID || product.Product_ID;
          const description = productDetails.Description || "";

          var productDisplayCode = `
            <div class="cart-item opacity-50">
                <div class="cart-item-img-wrap">
                    <img src="" class="cart-item-img ${product.Product_ID}-prodNotAvailImg">
                </div>
                <div class="cart-item-info">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="cart-item-name">${product.ProductName}</div>
                        ${IsVegOrNonVeg}
                    </div>
                    <div class="cart-item-desc">${description}</div>
                    <div class="cart-item-footer">
                        <div class="cart-item-price">₹${product.Price}</div>
                        <div class="badge bg-danger rounded-pill">Out of Stock</div>
                    </div>
                    <div class="small text-muted mt-1">GST: ₹${productGST}</div>
                </div>
            </div>`;
          $(".productsOutOfStock").append(productDisplayCode);
        });
      }
    } else {
      $(".mainCartPageContent").removeClass("d-none");
      $(".emptyCartPage").addClass("d-none");

      $(".cartProducts").empty();

      $(".itemsInCartCount").html(cartProducts.length);

      cartProducts.forEach((product) => {
        var productGST = product.Price * (product.GST / 100);
        productGST = Math.round(productGST);
        var IsVegOrNonVeg = "";

        if (product.Veg_NonVeg_flag != false) {
          if (product.Veg_NonVeg_flag == "Non-Veg") {
            IsVegOrNonVeg = `<div class="col-5 d-flex justify-content-end pl-0">
              <h5 class="card-title text-danger">Non-Veg</h5>
          </div>`;
          } else {
            IsVegOrNonVeg = `<div class="col-5 d-flex justify-content-end pl-0">
              <h5 class="card-title text-success">Veg</h5>
          </div>`;
          }
        }

        const productDetails = product.Product_Details || {};
        const productURL = productDetails.product_URL || "#";
        const description = productDetails.Description || "";

        var productDisplayCode = `
            <div class="cart-item">
                <div class="cart-item-img-wrap">
                    <a href="${globalThis.baseURL}customer/productSummary/${productURL}">
                        <img src="" class="cart-item-img ${product.Product_ID}-prodImg">
                    </a>
                </div>
                <div class="cart-item-info">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="cart-item-name">${product.ProductName}</div>
                        ${IsVegOrNonVeg}
                    </div>
                    <div class="cart-item-desc">${description}</div>
                    <div class="cart-item-footer">
                        <div class="cart-item-price">₹${product.Price}</div>
                        
                        <div class="qty-control">
                            <button class="qty-btn minusButtonCart" value="${product.Product_ID}">-</button>
                            <span class="qty-val cartItemQuantityNumber" name="${product.Product_ID}">${product.Quantity || 0}</span>
                            <button class="qty-btn plusButtonCart" value="${product.Product_ID}">+</button>
                        </div>
                    </div>
                    <div class="small text-muted mt-1">GST: ₹${productGST}</div>
                    <p class="text-danger errorMsg small mt-1 mb-0" value="${product.Product_ID}"></p>
                </div>
            </div>`;
        $(".cartProducts").append(productDisplayCode);

        //Products Not in cart
        if (cartProductsNotAvaialable.length == 0) {
          $(".productsOutOfStockButInCart").addClass("d-none");
        } else {
          $(".productsOutOfStock").empty();

          $(".itemsOutOfStockCount").html(cartProductsNotAvaialable.length);

          cartProductsNotAvaialable.forEach((product) => {
            var productGST = product.Price * (product.GST / 100);
            productGST = Math.round(productGST);
            var IsVegOrNonVeg = "";

            if (product.Veg_NonVeg_flag != false) {
              if (product.Veg_NonVeg_flag == "Non-Veg") {
                IsVegOrNonVeg = `<div class="col-5 d-flex justify-content-end pl-0">
              <h5 class="card-title text-danger">Non-Veg</h5>
          </div>`;
              } else {
                IsVegOrNonVeg = `<div class="col-5 d-flex justify-content-end pl-0">
              <h5 class="card-title text-success">Veg</h5>
          </div>`;
              }
            }

            const productDetails = product.Product_Details || {};
            const productURL = productDetails.product_URL || "#";
            const description = productDetails.Description || "";

            var productDisplayCode = `<div class="card ">
      <div class="row ">
      
          <a class="col-4 col-lg-3 d-flex align-items-around" href="${globalThis.baseURL}customer/productSummary/${productURL}">
              <img src="" class="rounded-3 ${product.Product_ID}-prodNotAvailImg"></img>
          </a>
          
          <div class="col-8 col-lg-9">
              <div class="card-body pl-1 pb-0">
                  <div class="row">
                      <div class="col d-flex justify-content-start pr-0">
                          <h5 class="card-title truncate-one-cart">${product.ProductName}</h5>
                      </div>
                      ${IsVegOrNonVeg}
                  </div>
                  <p class="card-text truncate-cart">${description}</p>
                
                  <div class="row">
                      <div class="col d-flex align-items-end">
                          <h6 class="card-title" style="color: #35558a;">₹${product.Price}</h6>
                          
                      </div>
                  </div>
                  <div class="row d-flex justify-content-start">
                  <h6 class="card-title" style="color: #35558a;">GST : ₹${productGST}</h6>     
              </div>
                  <p class="text-danger errorMsg" value="${product.Product_ID}"></p>
              </div>
          </div>
      </div>
  </div>
  <br>`;
            $(".productsOutOfStock").append(productDisplayCode);
          });
        }
      });
      $(".plusButtonCart").on("off");
      $(".plusButtonCart").on("click", this.plusItemFunction);
      $(".plusButtonCart").on("off");
      $(".minusButtonCart").on("click", this.minusItemFunction);

      this.detailedBill();
      //for product available images
      cartProducts.forEach(async (product) => {
        var productImg = getImageUrl(
          product?.Product_Details?.Image_URL || product.Image_URL,
        );
        $(`.${product.Product_ID}-prodImg`).attr("src", productImg);
      });

      //for product not available images
      cartProductsNotAvaialable.forEach(async (product) => {
        var productImg = getImageUrl(
          product?.Product_Details?.Image_URL || product.Image_URL,
        );
        $(`.${product.Product_ID}-prodNotAvailImg`).attr("src", productImg);
      });

      cartProductsNotAvaialable.forEach(async (product) => {});
    }

    CartObject.notifyCartUpdate();
  };

  plusItemFunction = (event) => {
    //
    //
    //

    // var productID = $(event.currentTarget).val();

    // var itemQuantity = $(event.currentTarget)
    //   .parent()
    //   .siblings(".page-item")
    //   .find(".cartItemQuantityNumber")
    //   .val();
    var productID = event.currentTarget.value;

    var itemQuantityField = $(`.cartItemQuantityNumber[name="${productID}"]`);

    let itemCount = parseInt(itemQuantityField[0].innerHTML);

    // Optimistic UI update
    itemCount++;
    itemQuantityField[0].innerHTML = itemCount;

    this.debouncedUpdateCart(productID, itemCount);
    return;

    var maxItemQuantity = parseInt($(itemQuantityField[0]).attr("max"));

    var product = {
      Product_ID: productID,
      Quantity: itemCount + 1,
    };

    this.updateCart(product, event);
  };
  minusItemFunction = (event) => {
    const productID = event.currentTarget.value;
    const itemQuantityField = $(`.cartItemQuantityNumber[name="${productID}"]`);
    let itemCount = parseInt(itemQuantityField[0].innerHTML);

    if (itemCount <= 0) return;

    // Optimistic UI update
    itemCount--;
    itemQuantityField[0].innerHTML = itemCount;
    $(`.errorMsg[value='${productID}']`).html("");

    this.debouncedUpdateCart(productID, itemCount);
  };

  debouncedUpdateCart = (productID, quantity) => {
    if (quantityDebounceTimer) {
      clearTimeout(quantityDebounceTimer);
    }

    pendingQuantityUpdates[productID] = quantity;

    // Show optimistic total immediately
    this.updateOptimisticBill();

    quantityDebounceTimer = setTimeout(() => {
      // Show sync indicator before starting server updates
      $(".totalPrice").addClass("opacity-50");
      if (!$(".sync-indicator").length) {
        $(".totalPrice").parent().append('<i class="fa fa-spinner fa-spin ms-2 sync-indicator text-brand" style="font-size: 1rem;"></i>');
      }

      // Process all pending updates
      const updates = { ...pendingQuantityUpdates };
      for (const key in pendingQuantityUpdates) delete pendingQuantityUpdates[key];
      
      const updatePromises = Object.entries(updates).map(([pID, qty]) => {
        return this.updateCart({ Product_ID: pID, Quantity: qty });
      });

      Promise.all(updatePromises).then(async () => {
        // Clear caches and force a fresh fetch from the server
        CartObject.clearCartCaches();
        quantityDebounceTimer = null;
        
        // Fetch fresh cart once and update everything
        const freshCart = await CartObject.cartCheck(true);
        this.showProductsOnCartPage(freshCart);
        this.detailedBill(freshCart);
      });
    }, QUANTITY_DEBOUNCE_MS);
  };

  updateOptimisticBill = async () => {
    const cart = await CartObject.cartCheck();
    if (!cart || !cart.Order || !cart.Products) return;

    // Clone cart objects to avoid mutating cache
    const optimisticOrder = { ...cart.Order };
    const products = cart.Products;

    let totalAmount = 0;
    let totalGST = 0;

    products.forEach((product) => {
      const qty = pendingQuantityUpdates.hasOwnProperty(product.Product_ID)
        ? pendingQuantityUpdates[product.Product_ID]
        : product.Quantity;

      const price = parseFloat(product.Price);
      const gstPercent = parseFloat(product.GST || 0);

      totalAmount += price * qty;
      
      let itemGst = price * (gstPercent / 100);
      itemGst = Math.round(itemGst); // Backend rounds GST per unit usually
      totalGST += itemGst * qty;
    });

    optimisticOrder.Order_Amount = totalAmount;
    optimisticOrder.GST = totalGST;
    
    // Final Bill = Order_Amount + Packaging + GST - Discount
    optimisticOrder.Final_Bill_Amount = 
      totalAmount + 
      parseFloat(optimisticOrder.Packaging_charges || 0) + 
      totalGST - 
      parseFloat(optimisticOrder.Coupon_discount || 0);

    this.detailedBill(optimisticOrder);
  };

  updateCart = (product) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: baseURL + "api/customer/Cart/AddtoCart",
        type: "POST",
        data: {
          Vendor_ID: vendor.Vendor_ID,
          Product_ID: product.Product_ID,
          Quantity: product.Quantity,
          Type: "UPDATE_QTY",
        },
        headers: { Authorization: X_API_KEY },
        success: (result) => {
          resolve(result);
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  };

  //validations for address
  addAdressValidationCheck = (e) => {
    e.preventDefault();

    let isAddressNameValidated = this.AddressName_validate();
    if (isAddressNameValidated) {
      this.inputAddressNameError.html("");
    }

    let isAddressValidated = this.Address_validate();
    if (isAddressValidated) {
      this.inputAddressError.html("");
    }

    let isAddressshortValidated = this.Addressshort_validate();
    if (isAddressshortValidated) {
      this.inputAddressshortError.html("");
    }

    // let isLandmarkValidated = this.Landmark_validate();
    // if (isLandmarkValidated) {
    //
    //   this.inputLandmarkError.html("");
    // }

    let isCityValidated = this.City_validate();
    if (isCityValidated) {
      this.inputCityError.html("");
    }

    let isStateValidated = this.State_validate();
    if (isStateValidated) {
      this.inputStateError.html("");
    }

    let isPincodeValidated = this.Pincode_validate();
    if (isPincodeValidated) {
      this.inputpincodeError.html("");
    }

    if (
      isAddressNameValidated &&
      isAddressValidated &&
      isAddressshortValidated &&
      isCityValidated &&
      isStateValidated &&
      isPincodeValidated
    ) {
      this.submitNewAdress();
    }
  };

  AddressName_validate = () => {
    let flag = true;

    if (this.inputAddressName.val().length < 4) {
      this.inputAddressNameError.html(
        "Address Name should be minimum 4 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  Address_validate = () => {
    let flag = true;

    if (this.inputAddress.val().length < 5) {
      this.inputAddressError.html(
        "Address should be minimum 5 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  Addressshort_validate = () => {
    let flag = true;
    if (this.inputAddressshort.val().length < 5) {
      this.inputAddressshortError.html(
        "Landmark should be minimum 5 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  City_validate = () => {
    let flag = true;

    var cityExample = /^[A-Za-z0-9 ]+$/;

    if (
      !this.inputCity.val().match(cityExample) ||
      this.inputCity.val().length < 3
    ) {
      this.inputCityError.html(
        "City should be minimum 3 characters long and should not contain special characters!",
      );

      flag = false;
    }

    return flag;
  };

  State_validate = () => {
    let flag = true;

    var stateExample = /^[A-Za-z0-9 ]+$/;

    if (
      !this.inputState.val().match(stateExample) ||
      this.inputState.val().length < 3
    ) {
      this.inputStateError.html(
        "State should be minimum 3 characters long and should not contain special characters!",
      );

      flag = false;
    }

    return flag;
  };

  Pincode_validate = () => {
    let flag = true;

    var pincodeExample = /^[0-9]*$/;

    if (
      !this.inputPincode.val().match(pincodeExample) ||
      this.inputPincode.val().length < 6
    ) {
      this.inputpincodeError.html(
        "Pincode should be minimum 6 characters long and should contain only numbers!",
      );

      flag = false;
    }

    return flag;
  };

  detailedBill = async (cart = null, optimisticOrder = null) => {
    if (!cart) {
        cart = await CartObject.cartCheck();
    }
    var cartOrder = optimisticOrder || cart.Order;

    if (!cartOrder) return;

    // Remove sync indicator if this is server-confirmed data
    if (!optimisticOrder) {
      $(".totalPrice").removeClass("opacity-50");
      $(".sync-indicator").remove();
    }

    if (cartOrder.Coupon_ID == "" || cartOrder.Coupon_ID == null) {
      $(".applyCouponBox").show();
      this.removeCouponBox.hide();
      $(".offersDiscountRow").addClass("d-none");
    } else {
      this.removeCouponBox.show();
      $(".applyCouponBox").hide();
      this.couponEntered.val(cart?.coupon?.Coupon_Code || "");
      $(".offersDiscountRow").removeClass("d-none");
    }

    $(".itemsTotal").html(cartOrder.Order_Amount);
    $(".offersDiscount").html(cartOrder.Coupon_discount || 0);
    $(".packagingCharges").html(cartOrder.Packaging_charges || 0);
    $(".gstAmount").html(cartOrder.GST);

    //getting delivery charges
    var deliveryChargesText = $(".deliveryCharges").html();
    var deliveryCharges = parseInt(deliveryChargesText) || 0;

    var finalBillAmount =
      parseInt(cartOrder.Final_Bill_Amount) + deliveryCharges;
    $(".totalPrice").html(finalBillAmount);
  };

  refreshCartCount = async (cart = null) => {
    this.noOfProductsInCart = cart || await CartObject.cartCheck();

    const count = (this.noOfProductsInCart && this.noOfProductsInCart.Products) ? this.noOfProductsInCart.Products.length : 0;
    $("span.cartCount").html(`${count}`);
  };

  //adding new address
  submitNewAdress = async () => {
    $(".deliveryoptions").hide();

    var customer = UtilObject.getAllCookies();

    $.ajax({
      url: baseURL + "api/customer/Account/AddAddress",
      type: "POST",
      data: {
        // Customer_ID: 'b27e453c-c54d-404f-b377-d3e67c90fca0',
        Customer_ID: customer.CUSTOMER_ID,
        Address_Line_1: this.inputAddress.val(),
        Landmark: this.inputAddressshort.val(),
        City: this.inputCity.val(),
        State: this.inputState.val(),
        Pincode: this.inputPincode.val(),
        Address_Name: this.inputAddressName.val(),
        lat: $(".inputLat").val(),
        lon: $(".inputLon").val(),
      },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        //check if user has address
        $.ajax({
          url: baseURL + "api/customer/Account/getAddress",
          type: "POST",
          data: {
            // Customer_ID: 'b27e453c-c54d-404f-b377-d3e67c90fca0',
            Customer_ID: customer.CUSTOMER_ID,
          },
          headers: { Authorization: X_API_KEY },
          success: (result) => {
            // Close the modal properly using Bootstrap's modal method
            window.$("#locationCallCart").modal("hide");
            
            $(".cartUserSavedAdress").empty();

            //   result.forEach((element) => {
            //     var classAdress =
            //       element.Address_Line_1 +
            //       element.Landmark +
            //       element.City +
            //       element.State;
            //     if (classAdress.length < 51) {
            //       var spacing = "pb-5";
            //     } else if (classAdress.length < 110) {
            //       var spacing = "pb-4";
            //     } else {
            //       var spacing = "pb-1";
            //     }
            //     var item = `<div class="col-sm-6 pt-2 cartAddressItem">
            //     <label class="card rounded-3 shadow-sm mb-1">
            //         <input type="radio" name="optDeliveryAdressradio" class="card-input-elementCart" value="${element.Customer_Address_ID}" />
            //         <div class="card-body card-input ${spacing}">
            //             <h5 class="card-title">${element.Address_Name}</h5>
            //             <div class=" truncate-cart-address">
            //             <p class="card-text"> ${element.Address_Line_1}, ${element.Landmark}, ${element.City}, ${element.State}</p>
            //             </div>
            //             <input type="hidden" name="lat" value="${element.lat}" />
            //             <input type="hidden" name="lon" value="${element.lon}" />
            //         </div>
            //     </label>
            // </div>`;
            //     $(".cartUserSavedAdress").append(item);
            //   });

            result.forEach((element) => {
              var classAdress = element.Address_Line_1;

              var item = `<div class="col-sm-6 pt-2 cartAddressItem">
              <label class="card h-100 rounded-3 shadow-sm mb-1">
                  <input id="${element.Customer_Address_ID}" type="radio" name="optDeliveryAdressradio" class="card-input-elementCart" value="${element.Customer_Address_ID}" />
                  <div class="card-body card-input">
                      <h5 class="card-title">${element.Address_Name}</h5>
                      <div class="truncate-cart-address">
                      <div id="${element.Customer_Address_ID}" class="card-text" style="width: 100%; 
                      line-height: 25px">${element.Address_Line_1}</div>
                      </div>
                      <input type="hidden" name="lat" value="${element.lat}" />
                      <input type="hidden" name="lon" value="${element.lon}" />
                  </div>
              </label>
          </div>`;

              $(".cartUserSavedAdress").append(item);
            });

            $(".cartUserSavedAdress .cartAddressItem").on(
              "click",
              this.getAllVendorDeliveryoptions,
            );

            if (result.length == 1) {
              $(`#${result[0].Customer_Address_ID}`).attr("checked", "checked");
              $(".cartAddressItem").trigger("click");
            }
          },
          error: (err) => {
            $(".signInCartBtn").addClass("d-none");
            $(".addressCartBtn").removeClass("d-none");
          },
        });
      },
      error: (err) => {},
    });
  };

  /*
  sendSmsAndEmail = (Order_ID) => {
    const deferred = $.Deferred();
    //Getting order details first.
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderDetails",
      type: "POST",
      data: {
        Order_ID: Order_ID,
      },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        const finalOrderDetails = result;
        const finalOrderCustomer = finalOrderDetails.Customer_details;
        const finalOrderVendor = finalOrderDetails.Vendor_details;
        const finalOrder = finalOrderDetails.Order;
        const finalOrderProducts = finalOrderDetails.Order_products;

        // Chain the next calls or use Promise.all
        const smsPromise = $.ajax({
          url: baseURL + "api/Msg91/sendVendorOrderSMS",
          type: "POST",
          data: {
            vendorName: finalOrderVendor.Business_Name,
            vendorPhoneNumber: finalOrderVendor.Phone_Number,
            orderNumber: finalOrder.Order_No,
          },
          headers: { Authorization: X_API_KEY }
        });

        // Email logic (omitted for brevity in this chunk, will be updated in next)
        this.processEmails(finalOrderDetails).always(() => {
          deferred.resolve();
        });
      },
      error: (error) => {
        console.error("Failed to fetch order details for notifications:", error);
        deferred.resolve(); // Still resolve to allow redirection
      },
    });
    return deferred.promise();
  };
  */

  /*
  processEmails = (finalOrderDetails) => {
    const deferred = $.Deferred();
    const promises = [];
    const finalOrderCustomer = finalOrderDetails.Customer_details;
    const finalOrderVendor = finalOrderDetails.Vendor_details;
    const finalOrder = finalOrderDetails.Order;
    const finalOrderProducts = finalOrderDetails.Order_products;
    var emailProducts = ``;
    var emailProductsForVendor = ``;
    finalOrderProducts.forEach((product) => {
      var data = `<tr>
      <td style="line-height: 24px; font-size: 16px; width: 100%; margin: 0; padding: 8px;" align="left" width="100%">${product.ProductName} x ${product.Quantity}</td>
      <td class="text-right" style="line-height: 24px; font-size: 16px; width: 100%; margin: 0; padding: 8px;" align="right" width="100%">&#8377;${product.Price}</td>
    </tr>`;

      var dataForVendor = `<tr>
    <td style="line-height: 24px; font-size: 16px; width: 100%; margin: 0; padding: 8px;" align="left" width="100%">${product.ProductName} x ${product.Quantity}</td>
  </tr>`;

      emailProducts = emailProducts + data;
      emailProductsForVendor = emailProductsForVendor + dataForVendor;
    });

    //check for final amount, coupon discount in orders
    if (finalOrder.Coupon_ID != null) {
      emailProducts =
        emailProducts +
        `<tr>
      <td class="fw-700 border-top" style="line-height: 24px; font-size: 16px; border-top-width: 1px !important; border-top-color: #e2e8f0 !important; border-top-style: solid !important; width: 100%; font-weight: 700 !important; margin: 0; padding: 8px;" align="left" width="100%">Coupon Discount</td>
      <td class="fw-700 text-right border-top" style="line-height: 24px; font-size: 16px; border-top-width: 1px !important; border-top-color: #e2e8f0 !important; border-top-style: solid !important; width: 100%; font-weight: 700 !important; margin: 0; padding: 8px;" align="right" width="100%">&#8377;${finalOrder.Coupon_discount}</td>
    </tr>`;
    }

    if (finalOrder.Delivery_Charges != "0") {
      emailProducts =
        emailProducts +
        `<tr>
      <td class="fw-700 border-top" style="line-height: 24px; font-size: 16px; border-top-width: 1px !important; border-top-color: #e2e8f0 !important; border-top-style: solid !important; width: 100%; font-weight: 700 !important; margin: 0; padding: 8px;" align="left" width="100%">Delivery Charges</td>
      <td class="fw-700 text-right border-top" style="line-height: 24px; font-size: 16px; border-top-width: 1px !important; border-top-color: #e2e8f0 !important; border-top-style: solid !important; width: 100%; font-weight: 700 !important; margin: 0; padding: 8px;" align="right" width="100%">&#8377;${finalOrder.Delivery_Charges}</td>
    </tr>`;
    }

    if (finalOrder.Packaging_charges != "0") {
      emailProducts =
        emailProducts +
        `<tr>
      <td class="fw-700 border-top" style="line-height: 24px; font-size: 16px; border-top-width: 1px !important; border-top-color: #e2e8f0 !important; border-top-style: solid !important; width: 100%; font-weight: 700 !important; margin: 0; padding: 8px;" align="left" width="100%">Packaging charges</td>
      <td class="fw-700 text-right border-top" style="line-height: 24px; font-size: 16px; border-top-width: 1px !important; border-top-color: #e2e8f0 !important; border-top-style: solid !important; width: 100%; font-weight: 700 !important; margin: 0; padding: 8px;" align="right" width="100%">&#8377;${finalOrder.Packaging_charges}</td>
    </tr>`;
    }

    emailProducts =
      emailProducts +
      `<tr>
      <td class="fw-700 border-top" style="line-height: 24px; font-size: 16px; border-top-width: 1px !important; border-top-color: #e2e8f0 !important; border-top-style: solid !important; width: 100%; font-weight: 700 !important; margin: 0; padding: 8px;" align="left" width="100%">GST</td>
      <td class="fw-700 text-right border-top" style="line-height: 24px; font-size: 16px; border-top-width: 1px !important; border-top-color: #e2e8f0 !important; border-top-style: solid !important; width: 100%; font-weight: 700 !important; margin: 0; padding: 8px;" align="right" width="100%">&#8377;${finalOrder.GST}</td>
    </tr>`;

    emailProducts =
      emailProducts +
      `<tr>
      <td class="fw-700 border-top" style="line-height: 24px; font-size: 16px; border-top-width: 1px !important; border-top-color: #e2e8f0 !important; border-top-style: solid !important; width: 100%; font-weight: 700 !important; margin: 0; padding: 8px;" align="left" width="100%">Enquiry Amount</td>
      <td class="fw-700 text-right border-top" style="line-height: 24px; font-size: 16px; border-top-width: 1px !important; border-top-color: #e2e8f0 !important; border-top-style: solid !important; width: 100%; font-weight: 700 !important; margin: 0; padding: 8px;" align="right" width="100%">&#8377;${finalOrder.Final_Bill_Amount}</td>
    </tr>`;

    var tempCustomerEmailStatus = finalOrderCustomer.Email_status;

    //if customer email is valid only then send it
    if (tempCustomerEmailStatus.toLowerCase() == "valid") {
      var BodyHtml = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
      <html>
        <head>
          <!-- Compiled with Bootstrap Email version: 1.3.1 -->
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
          <meta http-equiv="x-ua-compatible" content="ie=edge">
          <meta name="x-apple-disable-message-reformatting">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <meta name="format-detection" content="telephone=no, date=no, address=no, email=no">
          <style type="text/css">
            body,table,td{font-family:Helvetica,Arial,sans-serif !important}.ExternalClass{width:100%}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div{line-height:150%}a{text-decoration:none}{color:inherit}a[x-apple-data-detectors],u+#body a,#MessageViewBody a{color:inherit;text-decoration:none;font-size:inherit;font-family:inherit;font-weight:inherit;line-height:inherit}img{-ms-interpolation-mode:bicubic}table:not([class^=s-]){font-family:Helvetica,Arial,sans-serif;mso-table-lspace:0pt;mso-table-rspace:0pt;border-spacing:0px;border-collapse:collapse}table:not([class^=s-]) td{border-spacing:0px;border-collapse:collapse}@media screen and (max-width: 600px){.w-lg-48,.w-lg-48>tbody>tr>td{width:auto !important}.w-full,.w-full>tbody>tr>td{width:100% !important}.w-16,.w-16>tbody>tr>td{width:64px !important}.p-lg-10:not(table),.p-lg-10:not(.btn)>tbody>tr>td,.p-lg-10.btn td a{padding:0 !important}.p-2:not(table),.p-2:not(.btn)>tbody>tr>td,.p-2.btn td a{padding:8px !important}.pr-4:not(table),.pr-4:not(.btn)>tbody>tr>td,.pr-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-right:16px !important}.pl-4:not(table),.pl-4:not(.btn)>tbody>tr>td,.pl-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-left:16px !important}.pr-6:not(table),.pr-6:not(.btn)>tbody>tr>td,.pr-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-right:24px !important}.pl-6:not(table),.pl-6:not(.btn)>tbody>tr>td,.pl-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-left:24px !important}.pt-8:not(table),.pt-8:not(.btn)>tbody>tr>td,.pt-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-top:32px !important}.pb-8:not(table),.pb-8:not(.btn)>tbody>tr>td,.pb-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-bottom:32px !important}*[class=s-lg-]>tbody>tr>td{font-size:0 !important;line-height:0 !important;height:0 !important}.s-4>tbody>tr>td{font-size:16px !important;line-height:16px !important;height:16px !important}.s-6>tbody>tr>td{font-size:24px !important;line-height:24px !important;height:24px !important}}
          </style>
        </head>
        <body class="bg-red-100" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
          <table class="bg-red-100 body" valign="top" role="presentation" border="0" cellpadding="0" cellspacing="0" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
            <tbody>
              <tr>
                <td valign="top" style="line-height: 24px; font-size: 16px; margin: 0;" align="left" bgcolor="#ff385c">
                  <table class="container" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                    <tbody>
                      <tr>
                        <td align="center" style="line-height: 24px; font-size: 16px; margin: 0; padding: 0 16px;">
                          <!--[if (gte mso 9)|(IE)]>
                            <table align="center" role="presentation">
                              <tbody>
                                <tr>
                                  <td width="600">
                          <![endif]-->
                          <table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                            <tbody>
                              <tr>
                                <td style="line-height: 24px; font-size: 16px; margin: 0;" align="left">
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <img class="w-16" src="https://Locaso-pro-data-public.s3.ap-south-1.amazonaws.com/Public_Pictures/LocasoWhiteWithoutOrange.png" style="height: auto; line-height: 100%; outline: none; text-decoration: none; display: block; width: 64px; border-style: none; border-width: 0;" width="64">
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <div class="space-y-4">
                                    <h1 class="text-4xl fw-800" style="padding-top: 0; padding-bottom: 0; font-weight: 800 !important; vertical-align: baseline; font-size: 36px; line-height: 43.2px; margin: 0;" align="left">Thanks for your enquiry, ${
                                      finalOrderCustomer.Customer_Name
                                    }</h1>
                                    <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <p class="" style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left">Thanks for choosing Locaso. We&#39;ll send a confirmation when your enquiry has been accepted by the seller. Track your enquiry on the Locaso website.</p>
                                    <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table class="btn btn-red-500 rounded-full px-6 w-full w-lg-48" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 9999px; border-collapse: separate !important; width: 192px;" width="192">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 24px; font-size: 16px; border-radius: 9999px; width: 192px; margin: 0;" align="center" bgcolor="#dc3545" width="192">
                                            <a href="${
                                              baseURL +
                                              "customer/confirmationPage/" +
                                              Order_ID
                                            }" style="color: #ffffff; font-size: 16px; font-family: Helvetica, Arial, sans-serif; text-decoration: none; border-radius: 9999px; line-height: 20px; display: block; font-weight: normal; white-space: nowrap; background-color: #3335ec; padding: 8px 24px; border: 1px solid #3335ec;">Track Your Enquiry</a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table class="card rounded-3xl px-4 py-8 p-lg-10" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 24px; border-collapse: separate !important; width: 100%; overflow: hidden; border: 1px solid #e2e8f0;" bgcolor="#ffffff">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 16px; width: 100%; border-radius: 24px; margin: 0; padding: 40px;" align="left" bgcolor="#ffffff">
                                          <h3 class="text-center" style="padding-top: 0; padding-bottom: 0; font-weight: 500; vertical-align: baseline; font-size: 28px; line-height: 33.6px; margin: 0;" align="center">Enquiry Summary from Locaso</h3>
                                          <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Enquiry #${
                                            finalOrder.Order_No
                                          }</p>
                                          <table class="p-2 w-full" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              ${emailProducts}
                                            </tbody>
                                          </table>
                                          <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                  &#160;
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table class="hr" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 16px; border-top-width: 1px; border-top-color: #e2e8f0; border-top-style: solid; height: 1px; width: 100%; margin: 0;" align="left">
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                  &#160;
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <p style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left">If you have any questions, contact us at <a href="https://bootstrapemail.com" style="color: #0d6efd;"><span class="_cf_email_" data-cfemail="40082930032f3230002538212d302c256e232f2d">customer.support@Locaso.com</span></a>.</p>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!--[if (gte mso 9)|(IE)]>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                          <![endif]-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        <script data-cfasync="false" src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"></script></body>
      </html>
      `;
      //Api to send Email
      const customerPromise = $.ajax({
        url: baseURL + "api/AmazonSesSmtp/sendEmail",
        type: "POST",
        data: {
          SenderAddress: "customer.support@Locaso.com",
          ReceiverAddress: finalOrderCustomer.Email,
          Subject: `Your enquiry details for enquiry placed with Locaso : Enquiry Number-${finalOrder.Order_No}`,
          BodyText: `CUSTOMER ENQUIRY SUMMARY`,
          BodyHtml: BodyHtml,
        },
        headers: { Authorization: X_API_KEY },
        error: (err) => console.error("Customer Email Error:", err)
      });
      promises.push(customerPromise);
    }

    var tempVendorEmailStatus = finalOrderVendor.Email_status;
    //if vendor email is valid only then send it
    if (tempVendorEmailStatus.toLowerCase() == "valid") {
      var BodyHtmlForVendor = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
      <html>
        <head>
          <!-- Compiled with Bootstrap Email version: 1.3.1 -->
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
          <meta http-equiv="x-ua-compatible" content="ie=edge">
          <meta name="x-apple-disable-message-reformatting">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <meta name="format-detection" content="telephone=no, date=no, address=no, email=no">
          <style type="text/css">
            body,table,td{font-family:Helvetica,Arial,sans-serif !important}.ExternalClass{width:100%}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div{line-height:150%}a{text-decoration:none}{color:inherit}a[x-apple-data-detectors],u+#body a,#MessageViewBody a{color:inherit;text-decoration:none;font-size:inherit;font-family:inherit;font-weight:inherit;line-height:inherit}img{-ms-interpolation-mode:bicubic}table:not([class^=s-]){font-family:Helvetica,Arial,sans-serif;mso-table-lspace:0pt;mso-table-rspace:0pt;border-spacing:0px;border-collapse:collapse}table:not([class^=s-]) td{border-spacing:0px;border-collapse:collapse}@media screen and (max-width: 600px){.w-lg-48,.w-lg-48>tbody>tr>td{width:auto !important}.w-full,.w-full>tbody>tr>td{width:100% !important}.w-16,.w-16>tbody>tr>td{width:64px !important}.p-lg-10:not(table),.p-lg-10:not(.btn)>tbody>tr>td,.p-lg-10.btn td a{padding:0 !important}.p-2:not(table),.p-2:not(.btn)>tbody>tr>td,.p-2.btn td a{padding:8px !important}.pr-4:not(table),.pr-4:not(.btn)>tbody>tr>td,.pr-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-right:16px !important}.pl-4:not(table),.pl-4:not(.btn)>tbody>tr>td,.pl-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-left:16px !important}.pr-6:not(table),.pr-6:not(.btn)>tbody>tr>td,.pr-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-right:24px !important}.pl-6:not(table),.pl-6:not(.btn)>tbody>tr>td,.pl-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-left:24px !important}.pt-8:not(table),.pt-8:not(.btn)>tbody>tr>td,.pt-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-top:32px !important}.pb-8:not(table),.pb-8:not(.btn)>tbody>tr>td,.pb-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-bottom:32px !important}*[class=s-lg-]>tbody>tr>td{font-size:0 !important;line-height:0 !important;height:0 !important}.s-4>tbody>tr>td{font-size:16px !important;line-height:16px !important;height:16px !important}.s-6>tbody>tr>td{font-size:24px !important;line-height:24px !important;height:24px !important}}
          </style>
        </head>
        <body class="bg-red-100" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
          <table class="bg-red-100 body" valign="top" role="presentation" border="0" cellpadding="0" cellspacing="0" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
            <tbody>
              <tr>
                <td valign="top" style="line-height: 24px; font-size: 16px; margin: 0;" align="left" bgcolor="#ff385c">
                  <table class="container" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                    <tbody>
                      <tr>
                        <td align="center" style="line-height: 24px; font-size: 16px; margin: 0; padding: 0 16px;">
                          <!--[if (gte mso 9)|(IE)]>
                            <table align="center" role="presentation">
                              <tbody>
                                <tr>
                                  <td width="600">
                          <![endif]-->
                          <table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                            <tbody>
                              <tr>
                                <td style="line-height: 24px; font-size: 16px; margin: 0;" align="left">
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <img class="w-16" src="https://Locaso-pro-data-public.s3.ap-south-1.amazonaws.com/Public_Pictures/LocasoWhiteWithoutOrange.png" style="height: auto; line-height: 100%; outline: none; text-decoration: none; display: block; width: 64px; border-style: none; border-width: 0;" width="64">
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <div class="space-y-4">
                                    <h1 class="text-4xl fw-800" style="padding-top: 0; padding-bottom: 0; font-weight: 800 !important; vertical-align: baseline; font-size: 36px; line-height: 43.2px; margin: 0;" align="left">${
                                      finalOrderVendor.Business_Name
                                    } has received a new enquiry</h1>
                                    <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <p class="" style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left">Log in to your dashboard to update the status of the enquiry.</p>
                                    <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table class="btn btn-red-500 rounded-full px-6 w-full w-lg-48" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 9999px; border-collapse: separate !important; width: 192px;" width="192">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 24px; font-size: 16px; border-radius: 9999px; width: 192px; margin: 0;" align="center" bgcolor="#dc3545" width="192">
                                            <a href="${
                                              baseURL +
                                              "Vendor_servicing_dashboard"
                                            }" style="color: #ffffff; font-size: 16px; font-family: Helvetica, Arial, sans-serif; text-decoration: none; border-radius: 9999px; line-height: 20px; display: block; font-weight: normal; white-space: nowrap; background-color: #3335ec; padding: 8px 24px; border: 1px solid #3335ec;">Dashboard</a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table class="card rounded-3xl px-4 py-8 p-lg-10" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 24px; border-collapse: separate !important; width: 100%; overflow: hidden; border: 1px solid #e2e8f0;" bgcolor="#ffffff">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 16px; width: 100%; border-radius: 24px; margin: 0; padding: 40px;" align="left" bgcolor="#ffffff">
                                          <h3 class="text-center" style="padding-top: 0; padding-bottom: 0; font-weight: 500; vertical-align: baseline; font-size: 28px; line-height: 33.6px; margin: 0;" align="center">Enquiry Details from Locaso</h3>
                                          <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">ENQUIRY #${
                                            finalOrder.Order_No
                                          }</p>
                                          <table class="p-2 w-full" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              ${emailProductsForVendor}
                                            </tbody>
                                          </table>
                                          <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                  &#160;
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table class="hr" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 16px; border-top-width: 1px; border-top-color: #e2e8f0; border-top-style: solid; height: 1px; width: 100%; margin: 0;" align="left">
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                  &#160;
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <p style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left">If you have any questions, contact us at <a href="https://bootstrapemail.com" style="color: #0d6efd;"><span class="_cf_email_" data-cfemail="40082930032f3230002538212d302c256e232f2d">vendor.support@Locaso.com</span></a>.</p>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!--[if (gte mso 9)|(IE)]>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                          <![endif]-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        <script data-cfasync="false" src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"></script></body>
      </html>`;
    const vendorPromise = $.ajax({
      url: baseURL + "api/AmazonSesSmtp/sendEmail",
      type: "POST",
      data: {
        SenderAddress: "vendor.support@Locaso.com",
        ReceiverAddress: finalOrderVendor.Email_Address,
        Subject: `New enquiry received for your store at Locaso : Enquiry Number-${finalOrder.Order_No}`,
        BodyText: `VENDOR ENQUIRY DETAILS`,
        BodyHtml: BodyHtmlForVendor,
      },
      headers: { Authorization: X_API_KEY },
      error: (err) => console.error("Vendor Email Error:", err)
    });
    promises.push(vendorPromise);
    }

    $.when(...promises).always(() => {
      deferred.resolve();
    });

    // window.location = baseURL + `customer/confirmationPage/${finalOrder.Order_No}`;
  };
  */
}

